import React from "react";
import { Checkbox, TableCell, TableHead, TableRow } from "@mui/material";
import { GridColDef } from "./AppTable";

type AppTableHeadProps<T> = {
  selectedNum: number;
  rowCount: number;
  handleSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  columns: GridColDef<T>[];
  hasCheckbox: boolean;
};

function AppTableHead<T>(props: AppTableHeadProps<T>) {
  const { selectedNum, rowCount, columns, handleSelectAllClick, hasCheckbox } = props;

  return (
    <TableHead>
      <TableRow>
        {hasCheckbox && (
          <TableCell padding="checkbox">
            <Checkbox
              color="primary"
              indeterminate={selectedNum > 0 && selectedNum < rowCount}
              checked={rowCount > 0 && selectedNum === rowCount}
              onChange={handleSelectAllClick}
            />
          </TableCell>
        )}
        {columns.map(col => {
          return (
            <TableCell key={col.field} align={col.align}>
              {col.headerName}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}

export default AppTableHead;
